/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const dropdownItemOfintSchema = z.object({
  value: z.coerce.number().int(),
  label: z.coerce.string(),
});
